/**
 * Calcola il margine % tra prezzo di vendita e prezzo di acquisto.
 * Usa price_per_kg/cost_per_kg se disponibili (prodotti a peso),
 * altrimenti price/cost_price (prodotti a pezzo).
 *
 * Ritorna null se uno dei due è mancante o non valido.
 */
export function computeMargin(product) {
  if (!product) return null;
  const sellWeight = Number(product.price_per_kg) || 0;
  const costWeight = Number(product.cost_per_kg) || 0;
  const sellPiece = Number(product.price) || 0;
  const costPiece = Number(product.cost_price) || 0;

  let sell = 0;
  let cost = 0;
  if (sellWeight && costWeight) {
    sell = sellWeight;
    cost = costWeight;
  } else if (sellPiece && costPiece) {
    sell = sellPiece;
    cost = costPiece;
  } else {
    return null;
  }
  if (cost <= 0) return null;
  const pct = ((sell - cost) / cost) * 100;
  return {
    pct: Math.round(pct),
    sell,
    cost,
    absolute: Math.round((sell - cost) * 100) / 100,
  };
}

/**
 * Restituisce classe Tailwind + label in base al margine.
 * - ≥ 30% → verde (margine sano)
 * - 10-29% → giallo (margine basso)
 * - < 10% → rosso (margine insufficiente)
 * - negativo → rosso scuro (in perdita)
 */
export function marginTone(pct) {
  if (pct === null || pct === undefined) return null;
  if (pct < 0) return { cls: "bg-[#FCEAE8] text-[#8E3B2A] border-[#F2C4BE]", tone: "loss" };
  if (pct < 10) return { cls: "bg-[#FCEAE8] text-[#8E3B2A] border-[#F2C4BE]", tone: "low" };
  if (pct < 30) return { cls: "bg-[#FDF6E3] text-[#8B6518] border-[#F2DEB0]", tone: "mid" };
  return { cls: "bg-[#E8F3EC] text-[#2B5A3F] border-[#C5E1D1]", tone: "healthy" };
}
